<template>
  <nav class="navbar navbar-expand navbar-dark bd-navbar">
    <a class="navbar-brand" href="#">Indie42</a>
    <div class="collapse navbar-collapse">
      <ul class="nav navbar-nav bd-navbar-nav" id="myTab" role="tablist">
        <li class="nav-item">
          <router-link to="/static" class="nav-link">
            <i class="fas fa-book-open"></i>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/user" class="nav-link">
            <i class="fas fa-user-astronaut"></i>
          </router-link>
        </li>
      </ul>
    </div>
    <button v-show="!isWeb" type="button" class="btn btn-link" @click="doRefresh">
      <i class="fas fa-sync"></i>
    </button>
    <button
      type="button"
      class="btn btn-link"
      data-toggle="modal"
      data-target="#navModal"
    >
      <i class="fas fa-bars"></i>
    </button>
    <navbar-extra />
  </nav>
</template>

<script>
import NavbarExtra from "./Navbar.Extra.vue";

import { Plugins } from "@capacitor/core";
import "tuer-plugin";

const { TuerPlugin } = Plugins;

export default {
  name: "Navbar.Main",
  components: {
    NavbarExtra
  },
  data: function() {
    return {
      isWeb: false
    };
  },
  computed: {},
  created() {
    //Device.getInfo().then(info => this.isWeb = info.platform == 'web' );
    //Device.getInfo().then(info => this.what = info.platform );
    TuerPlugin.echo({ mode: "platform" }).then(ret => {
      this.isWeb = ret.value == "web";
    });
  },
  methods: {
    doRefresh: function() {
      window.location.reload(false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bd-navbar {
  background-color: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
.router-link-active {
  color: #000000;
}
</style>
